import React from 'react';
import { getPayoutTotalAmount, getPracticePayoutTotalAmount } from 'api/provider';

const useTotalPayoutsReceived = (
    timeRangeMonths?: number,
    isPractice = false,
): [number | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<number | undefined>(undefined);
    const fetchData = async () => {
        try {
            setLoading(true);
            const request = isPractice ? getPracticePayoutTotalAmount : getPayoutTotalAmount;
            const result = await request({ timeRangeMonths: timeRangeMonths || 0 });
            if (!result.error) {
                const data: number = result?.data?.data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (timeRangeMonths !== undefined) {
            fetchData();
        }
    }, [timeRangeMonths, isPractice]);

    return [items, loading, fetchData];
};

export default useTotalPayoutsReceived;
